import React, { useState } from 'react'
import DatePickerAntd from 'antd/lib/date-picker'
import { getMomentLocalDate } from '@/utils/dateUtilities'

export default function DatePicker (props) {
  const [calendarOpened, setCalendarOpened] = useState(false)

  return (
    <DatePickerAntd
      format='DD/MM/YYYY' {...props}
      onOpenChange={(status) => setCalendarOpened(status)}
      className={calendarOpened ? 'is-active' : ''}
      onChange={value => props.onChange(value)}
      value={getMomentLocalDate(props.value ? props.value : null)}
      disabledDate={(currentDate) => isDateDisabled(currentDate, props.min, props.max)}
      disabledTime={(date) => true} />
  )
}

function isDateDisabled (currentDate, min, max) {
  if ((min && currentDate.isBefore(min)) || (max && currentDate.isAfter(max))) {
    return true
  }

  return false
}



// WEBPACK FOOTER //
// ./src/components/DatePicker/DatePicker.js